import { OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-loggedout',
    templateUrl: './loggedout.component.html',
    styleUrls: ['./loggedout.component.scss']
})
export class LoggedOutComponent implements OnInit {


    constructor( private router: Router) {
    }

    ngOnInit() {
        // this.router.navigateByUrl('/');
    }
}
